module.exports = __webpack_public_path__ + "static/img/lang.b0428dfe.svg";